import { useState } from "react";
import useIsMobile from "components/hooks/useIsMobile";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Family } from "components/family/types";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TextField from "components/common/TextField";
import FlexBox from "components/common/FlexBox";

interface Props {
  family: Family;
}

const AddTask = ({ family }: Props) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const theme = useTheme();
  const [taskTitle, setTaskTitle] = useState<string>("");

  const handleCreateTask = () => {
    if (taskTitle) {
      navigate("/tasks/add", {
        state: { taskTitle, family: family },
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
      }}
    >
      <FlexBox direction="column" gap="4px">
        <Typography variant={isMobile ? "h3" : "h4"}>
          What needs to be done?
        </Typography>
        <Typography variant="body" color="text.secondary">
          You can add more details in the next step.
        </Typography>
      </FlexBox>
      <Box display="flex" flexDirection={"row"} alignItems="center" gap="12px">
        {/* Must wrap in form with autocomplete off to prevent signin prompt */}
        <form autoComplete="off" style={{ width: "100%" }}>
          <TextField
            autoComplete="off"
            name="newTaskTitle"
            variant="detachedOutlined"
            size="small"
            fullWidth
            defaultValue={taskTitle}
            onChange={(event) => setTaskTitle(event.target.value)}
            placeholder="Add a task"
            onKeyDown={(event) => {
              if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                handleCreateTask();
              }
            }}
            inputProps={{
              autoComplete: "off",
              spellCheck: "false",
              autoCorrect: "off",
              inputMode: "text",
            }}
          />
        </form>
        <Button
          onClick={handleCreateTask}
          disabled={!taskTitle.trim()}
          sx={{
            padding: "0px",
            height: "32px",
            width: "32px",
            minWidth: "32px",
            borderRadius: "50%",
          }}
        >
          <ArrowRight
            color={!taskTitle.trim() ? theme.palette.text.tertiary : undefined}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default AddTask;
